/* LiquidoException codes from our LIQUIDO backend. This file is auto generated! */

export default {
  "CANNOT_REGISTER_NEED_EMAIL" : 1,
  "CANNOT_UPDATE_USER" : 3,
  "CANNOT_UPLOAD_PICTURE" : 4,
  "TEAM_WITH_SAME_NAME_EXISTS" : 10,
  "CANNOT_CREATE_TEAM_ALREADY_REGISTERED" : 11,
  "CANNOT_JOIN_TEAM_INVITE_CODE_INVALID" : 12,
  "CANNOT_JOIN_TEAM_ALREADY_MEMBER" : 13,
  "CANNOT_JOIN_TEAM_ALREADY_ADMIN" : 14,
  "CANNOT_CREATE_TWILIO_USER" : 15,
  "USER_EMAIL_EXISTS" : 16,
  "USER_MOBILEPHONE_EXISTS" : 17,
  "PASSWORD_TOO_SHORT" : 18,
  "USER_HAS_NO_TEAM" : 19,
  "CANNOT_LOGIN_MOBILE_NOT_FOUND" : 20,
  "CANNOT_LOGIN_EMAIL_NOT_FOUND" : 21,
  "CANNOT_LOGIN_TOKEN_INVALID" : 22,
  "CANNOT_LOGIN_TEAM_NOT_FOUND" : 23,
  "CANNOT_LOGIN_USER_NOT_MEMBER_OF_TEAM" : 24,
  "CANNOT_LOGIN_INTERNAL_ERROR" : 25,
  "CANNOT_REQUEST_SMS_TOKEN" : 26,
  "WONT_RESET_PASSWORD" : 27,
  "WEBAUTHN_ERROR" : 28,
  "GOOGLE_LOGIN_GOOGLE_IDTOKEN_INVALID" : 30,
  "GOOGLE_LOGIN_GOOGLE_MUST_REGISTER" : 31,
  "JWT_TOKEN_INVALID" : 40,
  "JWT_TOKEN_EXPIRED" : 41,
  "INVALID_VOTER_TOKEN" : 50,
  "CANNOT_CREATE_POLL" : 51,
  "CANNOT_JOIN_POLL" : 52,
  "CANNOT_ADD_PROPOSAL" : 53,
  "CANNOT_START_VOTING_PHASE" : 54,
  "CANNOT_ASSIGN_PROXY" : 55,
  "CANNOT_ASSIGN_CIRCULAR_PROXY" : 56,
  "CANNOT_REMOVE_PROXY" : 57,
  "CANNOT_CAST_VOTE" : 58,
  "CANNOT_CREATE_VOTING_TOKEN" : 59,
  "CANNOT_FINISH_POLL" : 60,
  "NO_DELEGATION" : 61,
  "NO_BALLOT" : 62,
  "INVALID_POLL_STATUS" : 63,
  "PUBLIC_CHECKSUM_NOT_FOUND" : 64,
  "CANNOT_ADD_SUPPORTER" : 65,
  "CANNOT_EDIT_PROPOSAL" : 66,
  "CANNOT_UPDATE_POLL" : 67,
  "CANNOT_DELETE_PROPOSAL" : 68,
  "EMAIL_VERIFICATION_TOKEN_INVALID" : 69,
  "CANNOT_CALCULATE_UNIQUE_RANKED_PAIR_WINNER" : 70,
  "ALREADY_VOTED" : 71,
  "INVALID_VOTING_END" : 72,
  "VOTING_ENDED" : 73,
  "CANNOT_VERIFY_CHECKSUM" : 80,
  "INVALID_REQUEST" : 90,
  "GRAPHQL_ERROR" : 400,
  "UNAUTHORIZED" : 401,
  "CANNOT_FIND_USER" : 403,
  "CANNOT_FIND_ENTITY" : 404,
  "INTERNAL_ERROR" : 500
};